import { render, staticRenderFns } from "./DailyTaskCard.vue?vue&type=template&id=5ae56acc&scoped=true"
import script from "./DailyTaskCard.vue?vue&type=script&lang=js"
export * from "./DailyTaskCard.vue?vue&type=script&lang=js"
import style0 from "./DailyTaskCard.vue?vue&type=style&index=0&id=5ae56acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae56acc",
  null
  
)

export default component.exports